// extracted by css-extract-rspack-plugin
var _1 = "ai-config-tags-FtFsyG";
var _2 = "ai-config-tags-FtFsyG";
var _3 = "filter-fB1xEh";
var _4 = "model-cell-oaHW5V";
var _5 = "model-tags-p13WpJ";
var _6 = "model-cell-oaHW5V";
var _7 = "model-tags-p13WpJ";
var _8 = "name-cell-Up__Ak";
var _9 = "name-cell-Up__Ak";
var _a = "table-OQds_y";
export { _1 as "ai-config-tags", _2 as "aiConfigTags", _3 as "filter", _4 as "model-cell", _5 as "model-tags", _6 as "modelCell", _7 as "modelTags", _8 as "name-cell", _9 as "nameCell", _a as "table" }
